/*
 ** get post 请求封装
 ** 获取cookie中的cp参数，添加到所有的请求中
 ** cp参数安卓Native有可能不存在cookie里面，用PPDWebUI的appInfos()方法获取
 ** 添加原来http.js里面的header参数
 ** 获取登录的状态码（接口），如果是未登录的情况，跳转Ac登录页
 ** 所有请求异常上发接口
 ** 接口请求的loading
 */
 import util from './util.js';
 import compareAppVersion from '../util/compareAppVersion';
 let ajaxCount = [];
 
 export default class SetParams {
     constructor() {
         this.baseURL = window.location.origin + '/api';
     }
     handleError(response) {
         let {
             config,
             data, // 返回回来的对象
             request
         } = response;
         let status = response.status;
         let params = {
             errorCode: status,
             errorMessage:
                 (data && (data.message || data.Message || data.ResultMessage)) ||
                 request.statusText,
             requestURL: request.responseURL,
             method: config.method,
             userAgent: navigator.userAgent
         };
         // 如果监控报错不处理
         if (request.responseURL.indexOf('webuimonitor') > -1) {
             return;
         }
         // 如果是未登录(h5网关)跳转Ac
         if (params.errorMessage.indexOf('令牌') > -1 || params.errorCode === 400) {
            if (this.noToLogin) {
            } else { 
                params.eventType = 'h5_token_error';
                this.jumpToLogin();
            }
         } else {
             // 其余异常上报接口
             params.eventType = 'h5_ajax_error';
         }
         // toast 错误提示
         if (params.errorCode) {
             let toastMessage = '';
             if (params.errorCode && Number(params.errorCode) >= 400) {
                 if (this.showNetToast === false) {
                     toastMessage = '';
                 } else {
                     toastMessage = `系统繁忙，请稍后再试(${params.errorCode})`;
                 }
             }
             toastMessage && this.toastError(toastMessage);
         }
         return this.sendReport(params);
     }
 
     // 处理业务异常
     handleBusinessError(code, message) {
         if (this.showBusinessToast === false) {
             return;
         }
         let toastMessage = `${message}(${code})`;
         this.toastError(toastMessage);
     }
 
     // 处理超时:toast且上报数据
     handleTimeout(errMessage, config) {
         let params = {
             errorCode: '2003',
             errorMessage: errMessage,
             requestURL: config.url,
             method: config.method,
             userAgent: navigator.userAgent,
             eventType: 'h5_ajax_error'
         };
         let toastMessage = '网络出错，请稍后重试(2003)';
         this.toastError(toastMessage);
         return this.sendReport(params);
     }
 
     toastError(message) {
         let judgeToast = document.querySelector('.ppd-toast-wrap');
         if (judgeToast) {
             return;
         }
         let style = document.createElement('style');
         let cssText =
             '.ppd-toast-wrap{animation:showToast 0.5s;animation-fill-mode: forwards;position:fixed;z-index:9999999;top:50%;left:50%;transform:translate(-50%,-50%);max-width:80%;line-height:22px;padding:10px;text-align:center;border-radius:3px;background:rgba(0,0,0,0.9);color:#fff;font-size:14px;}@keyframes showToast{0% {opacity:0;} 100% {opacity:0.9;}}';
         style.innerHTML = cssText;
         document.head.appendChild(style);
         let el = document.createElement('div');
         el.className = 'ppd-toast-wrap';
         el.innerText = message;
         document.body.appendChild(el);
         setTimeout(() => {
             el.parentNode.removeChild(el);
         }, 2000);
     }
 
     sendReport(obj) {
         obj = obj || {};
         const params = {
             eventId: util.uuid(),
             eventType: '',
             errorMessage: '',
             method: '',
             openid: '',
             requestURL: '',
             url: window.location.href,
             errorCode: obj.errorCode,
             timestamp: util.setTimestamp(new Date()),
             userAgent: navigator.userAgent,
             platform: util.getUseragentKey().platform,
             version: util.getUseragentKey().version,
             duid: util.getUseragentKey().duid,
             pid: util.getUseragentKey().pid,
             appId: util.getUseragentKey().appId||util.getMiappUseragentKey().appId,
             buildType: util.getUseragentKey().buildType
         };
         let jsonBody = Object.assign(params, obj);
         if (window.PPDWebUI && window.PPDWebUI.os && window.PPDWebUI.os.inApp && compareAppVersion(PPDWebUI.appInfos.version, '9.8.0', '>', true)) {
             window.PPDWebUI.MonitorService && window.PPDWebUI.MonitorService.monitor(jsonBody, function () {
                 console.log('上报成功');
             }, function () {
                 console.log('上报失败');
             });
         } else {
             this.sending('webuimonitor/monitorWebUiService/h5DataReprot', {jsonBody}, 'post');
         }
     }
 
     afterResponse() {
         this.judgeAjaxOver();
     }
 
     sending(
         url,
         params,
         method,
         headers,
         showNetToast,
         showBusinessToast,
         showLoading,
         type,
         needCp,
         loadWidthMask,
         noToLogin
     ) {
         this.loadWidthMask = loadWidthMask;
         this.showNetToast = showNetToast;
         this.showBusinessToast = showBusinessToast;
         this.noToLogin = noToLogin;
         showLoading && this.judgeAjaxStart(url);
 
         if (type === 'multi') {
             this.baseURL = window.location.origin + '/ledsdk';
         }
         let _url = url;
         if (!url.includes('//')) {
             _url = url.charAt(0) === '/' ? this.baseURL + url : this.baseURL + '/' + url;
         }
         if (needCp) {
             let cp =
                 util.getCookie('cp') ||
                 (window.PPDWebUI && window.PPDWebUI.appInfos && window.PPDWebUI.appInfos.cp) ||
                 '';
             if (cp || !window.PPDWebUI || !window.PPDWebUI.getAppInfos) {
                 //判断cp参数是否有，如果没有，判断appinfos是否有，无则直接走axios，有则继续promise取
                 _url = this.setUrl(_url, cp);
                 let obj = this.setObjH5(_url, method, params, headers, type, showLoading);
                 return this.service(obj);
             } else {
                 return new Promise((resolve, reject) => {
                     window.PPDWebUI &&
                         window.PPDWebUI.getAppInfos &&
                         window.PPDWebUI.getAppInfos()
                             .then(appInfos => {
                                 let cp = appInfos.cp || '';
                                 _url = this.setUrl(_url, cp);
                                 let obj = this.setObjH5(
                                     _url,
                                     method,
                                     params,
                                     headers,
                                     type,
                                     showLoading
                                 );
                                 resolve(this.service(obj));
                             })
                             .catch(err => {
                                 _url = this.setUrl(_url, '');
                                 let obj = this.setObjH5(
                                     _url,
                                     method,
                                     params,
                                     headers,
                                     type,
                                     showLoading
                                 );
                                 resolve(this.service(obj));
                             });
                 });
             }
         } else {
             let obj = this.setObjH5(_url, method, params, headers, type, showLoading);
             return this.service(obj);
         }
     }
 
     // 请求等于1个才显示loading
     judgeAjaxStart(url) {
         ajaxCount.push(url);
 
         if (ajaxCount.length === 1) {
             util.addLoading(this.loadWidthMask);
         }
     }
 
     // 请求都发送结束，关闭loading
     judgeAjaxOver(url) {
         let i = -1;
         ajaxCount.length &&
             ajaxCount.find((item, index) => {
                 if (url.includes(item)) {
                     i = index;
                     return item;
                 }
             });
         if (i > -1) {
             ajaxCount.splice(i, 1);
         }
         if (ajaxCount.length <= 0) {
             ajaxCount.length = 0;
             util.removeLoading();
         }
     }
 
     setObjH5(url, method, params, headers, type) {
         headers = headers || {};
         if (window.PPDWebUI && compareAppVersion(window.PPDWebUI.os.buildVersion, '9.0.0.0', '<')) {
             delete headers['X-WEBUI-REQUEST'];
         }
         return {
             url,
             method,
             [method === 'get' ? 'params' : 'data']: params,
             headers: Object.assign(util.setHeader(type), headers)
         };
     }
 
     setUrl(url, cp) {
         let _url = '';
         if (url.includes('?')) {
             _url = url + '&cp=' + cp;
         } else {
             _url = url + '?cp=' + cp;
         }
         return _url;
     }
 
     jumpToLogin() {
         // 如果在App里面则调起app登录，否则跳转Ac
         if (window.PPDWebUI && window.PPDWebUI.os.inApp) {
             window.PPDWebUI.AccountService.auth(
                 {
                     url: document.location.href
                 },
                 success => {},
                 err => {}
             );
         } else {
             setTimeout(() => {
                 window.location.href =
                     '//account.ppdai.com/h5/login?returnUrl=' +
                     encodeURIComponent(window.location.href);
             }, 100);
         }
     }
 }
 
 window.addEventListener('hashchange', function(event) {
     ajaxCount = [];
     util.removeLoading();
 });
 